// ============================================================================
// INFORMED CONSENT REPOSITORY
// ARQUIVO: src/services/InformedConsentRepository.js
// RESPONSABILIDADE: Operações Firestore do InformedConsentEngine (petitions, docs).
// Criado: Fase 6.3 — mover Firestore direto de InformedConsentEngine.jsx para repositório.
// ============================================================================

import { addDoc, collection, doc, getDocs, onSnapshot, query, serverTimestamp, updateDoc, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const APP_ID = FIREBASE_CONFIG?.projectId || 'portalrda-f312d';
const DOCS_COL = ['artifacts', APP_ID, 'public', 'data', 'documents'];

/** Observa petições do cliente. */
export function watchClientPetitions(clientId, onData, onError) {
  const col = collection(db, ...DOCS_COL);
  return onSnapshot(
    query(col, where('clientId', '==', clientId), where('type', '==', 'PETITION')),
    (snap) => onData(snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }))),
    onError
  );
}

/** Cria/atualiza documento de consentimento informado. */
export async function saveInformedConsent(payload, clientId, selectedPetitionId, documentId, authEmail = null) {
  const docsCol = collection(db, ...DOCS_COL);
  let docId = documentId;

  const enrichedPayload = {
    ...payload,
    updatedAt: serverTimestamp(),
    updatedBy: authEmail || null,
  };

  if (docId) {
    await updateDoc(doc(docsCol, docId), enrichedPayload);
  } else {
    const existingSnap = await getDocs(
      query(docsCol, where('clientId', '==', clientId), where('type', '==', 'INFORMED_CONSENT'), where('parentDocumentId', '==', selectedPetitionId))
    );
    if (!existingSnap.empty) {
      docId = existingSnap.docs[0].id;
      await updateDoc(doc(docsCol, docId), enrichedPayload);
    } else {
      const ref = await addDoc(docsCol, { ...enrichedPayload, createdAt: serverTimestamp(), createdBy: authEmail || null, publicationVersion: 0 });
      await updateDoc(ref, { id: ref.id });
      docId = ref.id;
    }
  }

  await updateDoc(doc(docsCol, selectedPetitionId), { consentDocumentId: docId, updatedAt: serverTimestamp() });
  return docId;
}

/** Publica documento de consentimento (status PUBLISHED). */
export async function publishInformedConsent(documentId, data, authEmail = null) {
  const docsCol = collection(db, ...DOCS_COL);
  await updateDoc(doc(docsCol, documentId), {
    ...data,
    updatedAt: serverTimestamp(),
    updatedBy: authEmail || null,
  });
}
